import { render, staticRenderFns } from "./module4.vue?vue&type=template&id=08c846aa&scoped=true"
import script from "./module4.vue?vue&type=script&lang=js"
export * from "./module4.vue?vue&type=script&lang=js"
import style0 from "./module4.vue?vue&type=style&index=0&id=08c846aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c846aa",
  null
  
)

export default component.exports